const basestyle = ()=>({
    wrapper:{
        margin:'0 auto',
        maxWidth:'90%',
        width:'1160px',
        padding:'15px 0 0',
    }
})
export default basestyle;